import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import AvatarLibrary from "@/src/components/AvatarLibrary.tsx";
import { useAvatars } from "@/src/hooks/useAvatars.ts";
import { SavingIndicator } from "@/src/components/SavingIndicator.tsx";

const AvatarSettings: React.FC = () => {
  const { t } = useTranslation();
  const { savedAvatars, addAvatar, updateAvatar, removeAvatar, isSaving } =
    useAvatars();

  return (
    <div className="space-y-8">
      <SavingIndicator isSaving={isSaving} />
      <section className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">
          {t("settings.avatarLibrary")}
        </h2>
        <p className="text-sm text-gray-500">
          {t("settings.avatarLibraryDescription")}
        </p>

        <div className="overflow-hidden rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
          <AvatarLibrary
            avatars={savedAvatars}
            onAdd={addAvatar}
            onUpdate={updateAvatar}
            onRemove={removeAvatar}
          />
        </div>
      </section>
    </div>
  );
};

export const Route = createFileRoute("/settings/avatars")({
  component: AvatarSettings,
});
